import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';
export default {
  title: 'Renditions',
  attributeName: 'renditions',
  validationUrl:'live',
  hiddenJsonComponent:true,
  fields: [
    {
      attributeName: 'uniqueId',
      label: 'UNIQUEID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'parentUID',
      label: 'PARENTUID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'bitrate',
      type: FormInputTypes.SELECT,
      label: 'Bitrate',
      required: true,
      helpText: 'Set the Bitrate.',
      default:'12000',
      options: [
        { name: '18.000', value: '18000' },
        { name: '16.000', value: '16000' },
        { name: '14.000', value: '14000' },
        { name: '12.000', value: '12000' },
        { name: '10.000', value: '10000' },
        { name: '8.000', value: '8000' },
        { name: '6.000', value: '6000' },
        { name: '5.000', value: '5000' },
        { name: '4.000', value: '4000' },
        { name: '2.000', value: '2000' },
        { name: '1.000', value: '1000' },
        { name: '500', value: '500' },
        { name: 'custom', value: 'custom' },
      ],
      errorText: '',
    },
    {
      attributeName: 'customBitrate',
      label: 'Custom Bitrate',
      helpText: 'Select custom bitrate.',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      visibleWhen:{"field":"bitrate","value":"custom"},

    },
    {
      attributeName: 'scale',
      label: 'Scale',
      helpText: 'Type scale.',
      type: FormInputTypes.SELECT,
      default:'1',
      options: [
        { name: '1', value: '1' },
        { name: '0.75', value: '0.75' },
        { name: '0.50', value: '0.50' },
        { name: 'custom', value: 'custom' },
      ],
    },
    {
      attributeName: 'customScale',
      label: 'Custom Scale',
      helpText: 'Select custom scale.',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      visibleWhen:{"field":"scale","value":"custom"},

    },
  ]
};
